/** Distance from the bottom (px) beyond which the user is considered scrolled up. */
export const AUTOSCROLL_LEAVE_BOTTOM_PX = 32;

export const isScrolledAboveBottom = (
  el: HTMLElement,
  threshold = AUTOSCROLL_LEAVE_BOTTOM_PX
): boolean => {
  return el.scrollHeight - el.scrollTop - el.clientHeight > threshold;
};

export const scrollElementToBottom = (el: HTMLElement, behavior: ScrollBehavior = "smooth") => {
  el.scrollTo({ top: el.scrollHeight, behavior });
};

/**
 * Distinguishes user-driven scrolling (wheel, touch, scrollbar) from
 * programmatic stick-to-bottom updates so autoscroll is not disabled by itself.
 */
export const createUserScrollTracker = (idleMs = 250) => {
  let userScrolling = false;
  let timer: ReturnType<typeof setTimeout> | null = null;

  return {
    mark() {
      userScrolling = true;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        userScrolling = false;
      }, idleMs);
    },
    isUserScrolling() {
      return userScrolling;
    },
    dispose() {
      if (timer) clearTimeout(timer);
      timer = null;
      userScrolling = false;
    }
  };
};
